import React from 'react';
import { CheckIcon, GlobeIcon, TrophyIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { CountdownTimer } from './CountdownTimer';
import { ScarcityBar } from './ScarcityBar';
const ROWS = [{
  item: 'Kit Clínico para el Manejo de la Obesidad (6 Tomos)',
  value: '$97 USD'
}, {
  item: 'Kit de Algoritmos de Decisión Clínica',
  value: '$37 USD'
}, {
  item: 'Scripts Médicos para Mejorar la Adherencia',
  value: '$37 USD'
}, {
  item: 'Pack de Checklists Profesionales',
  value: '$27 USD'
}, {
  item: 'Plantillas de Educación para el Paciente',
  value: '$47 USD'
}, {
  item: 'Colección de Casos Clínicos Paso a Paso',
  value: '$37 USD'
}];
const PERKS = ['Descarga inmediata', 'Acceso permanente', 'Pago único', 'Garantía de 7 días'];
export function Offer() {
  return <section id="oferta" className="w-full bg-navy-900 px-4 py-14 text-white" data-id="element-138" data-mp="2fbofq5tz1egx">
      <div className="mx-auto max-w-2xl" data-id="element-139" data-mp="2ad3eq46waqrf">
        <div className="text-center" data-id="element-140" data-mp="2ac1v3bbtcvy3">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-gold px-3 py-1 text-[11px] font-extrabold uppercase tracking-widest text-navy-900" data-id="element-141" data-mp="2af7kyss9o1uv">
            <TrophyIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-142" data-mp="ui0kybf5l985" /> Oferta especial de lanzamiento
          </span>
          <h2 className="mt-4 font-display text-[26px] font-bold leading-tight sm:text-4xl" data-id="element-143" data-mp="ziwqetf5l3fo">
            Hoy no estás comprando un PDF.
          </h2>
          <p className="mx-auto mt-3 max-w-xl text-[15px] leading-relaxed text-white/70" data-id="element-144" data-mp="6u9918xiyy7e">
            Estás incorporando una Ruta Clínica completa para el manejo de la obesidad que podrás
            consultar cada vez que tengas un paciente frente a ti.
          </p>
        </div>

        <div className="mt-8 overflow-hidden rounded-2xl border border-white/15 bg-white/[0.06]" data-id="element-145" data-mp="kl4aw19lwf1h">
          <div className="flex items-center justify-between border-b border-white/10 px-4 py-2.5" data-id="element-146" data-mp="3k8lzept6dv0g">
            <span className="text-[11px] font-extrabold uppercase tracking-widest text-white/50" data-id="element-147" data-mp="3oa7jow81hbko">
              Lo que recibes hoy
            </span>
            <span className="text-[11px] font-extrabold uppercase tracking-widest text-white/50" data-id="element-148" data-mp="vefrbwq0fuyg">
              Valor
            </span>
          </div>
          <ul data-id="element-149" data-mp="155k4qs01f7r6">
            {ROWS.map(row => <li key={row.item} className="flex items-start justify-between gap-3 border-b border-white/10 px-4 py-3" data-id="element-150" data-mp="1550orgty6tfs">
                <span className="text-[13.5px] leading-snug text-white/85 sm:text-[15px]" data-id="element-151" data-mp="cg36vetneynk">
                  {row.item}
                </span>
                <span className="shrink-0 text-[13.5px] font-bold text-white/60 line-through sm:text-[15px]" data-id="element-152" data-mp="7jmhyiemkg9f">
                  {row.value}
                </span>
              </li>)}
          </ul>
          <div className="flex items-center justify-between px-4 py-3.5" data-id="element-153" data-mp="hi2dcxkoqboq">
            <span className="text-[13px] font-extrabold uppercase tracking-wide text-white" data-id="element-154" data-mp="1wv55n5ii0yc9">
              Valor total
            </span>
            <span className="font-display text-xl font-bold text-white/70 line-through" data-id="element-155" data-mp="1sxhac1cw93ju">
              $282 USD
            </span>
          </div>
        </div>

        <div className="mt-6 rounded-2xl border border-gold/40 bg-gold/10 p-5 text-center" data-id="element-156" data-mp="25fbirqox1fvr">
          <p className="text-[13px] font-semibold uppercase tracking-wide text-gold-light" data-id="element-157" data-mp="1qhrgwsnbg0tt">
            Hoy puedes obtener acceso por solo
          </p>
          <p className="mt-1 flex items-end justify-center gap-2" data-id="element-158" data-mp="2j55acgrt2e96">
            <span className="font-display text-2xl font-bold text-white/50 line-through" data-id="element-159" data-mp="2j5x19eagjnt4">$282</span>
            <span className="font-display text-5xl font-bold leading-none text-white sm:text-6xl" data-id="element-160" data-mp="2o3gk6ri3oore">
              $15
            </span>
          </p>
          <p className="mt-1 text-[13px] font-bold uppercase tracking-widest text-white/60" data-id="element-161" data-mp="2edx0jjmkcqvh">USD</p>
          <p className="mt-3 text-[14px] leading-relaxed text-white/75" data-id="element-162" data-mp="323hko5ugdu6c">
            En un único pago. Sin mensualidades. Sin renovaciones. Acceso de por vida.
          </p>
          <p className="mt-3 inline-flex items-center gap-1.5 rounded-full bg-white/10 px-3 py-1.5 text-[12px] font-semibold text-white/80" data-id="element-163" data-mp="1j6efep79v0zc">
            <GlobeIcon className="h-4 w-4 text-gold-light" aria-hidden="true" data-id="element-164" data-mp="1e69vsqb2hq4w" />
            El cambio de moneda es automático según tu país
          </p>
        </div>

        <div className="mt-7 flex flex-col items-center gap-4" data-id="element-165" data-mp="149dognwwna1x">
          <CTAButton label="QUIERO EL KIT CLÍNICO AHORA" data-id="element-166" data-mp="14b89e286f260" />
          <CountdownTimer data-id="element-167" data-mp="21vui9j6fj5ix" />
          <ScarcityBar spotsLeft={9} data-id="element-168" data-mp="21wcjyvbv2by8" />
          <ul className="mt-1 grid grid-cols-2 gap-x-4 gap-y-2" data-id="element-169" data-mp="1wxt3hag1dsd9">
            {PERKS.map(perk => <li key={perk} className="flex items-center gap-1.5 text-[13px] text-white/75" data-id="element-170" data-mp="1s6t3fwbmeu6j">
                <CheckIcon className="h-4 w-4 shrink-0 text-green-400" aria-hidden="true" data-id="element-171" data-mp="1n7zsaajt3f9j" />
                {perk}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}